var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPressureCuff = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-pressure-cuff_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161176",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31339",
  clipPath: "url(#icon-pressure-cuff_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38724",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38725",
  d: "M21.362 44.545h-3.8a1.02 1.02 0 01-1.02-1.02V18.422a1.02 1.02 0 011.02-1.019h3.8a1.02 1.02 0 011.02 1.019v25.1a1.02 1.02 0 01-1.02 1.02",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161175",
  fill: "#fff",
  d: "M20.936 17.019h26.396v27.525H20.936z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38726",
  d: "M53.321 43.391c1.422-2.761 1.338-5.786 0-7.676l.94-1.812-3.571-1.839-.939 1.812c-2.316.007-4.826 1.7-6.25 4.457s-1.338 5.786 0 7.676l-.939 1.813 3.57 1.84.941-1.813c2.317-.007 4.826-1.694 6.25-4.456",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1465",
  d: "M42.616 45.307h-8.611a.762.762 0 01-.762-.762.762.762 0 01.762-.762h8.611a.762.762 0 01.762.762.762.762 0 01-.762.762z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38727",
  d: "M31.107 45.307h-8.726a2.607 2.607 0 01-2.6-2.6V18.845a2.615 2.615 0 012.252-2.581.762.762 0 11.207 1.51 1.085 1.085 0 00-.935 1.071v23.857a1.082 1.082 0 001.081 1.081h8.726a.762.762 0 010 1.524z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38728",
  d: "M16.547 43.464a.762.762 0 01-.762-.762V18.846a2.607 2.607 0 012.6-2.6h27.1a2.607 2.607 0 012.6 2.6v11.862a.762.762 0 11-1.524 0V18.846a1.082 1.082 0 00-1.081-1.081h-27.1a1.082 1.082 0 00-1.081 1.081v23.857a.762.762 0 01-.752.761z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38729",
  d: "M46.129 50.422a.759.759 0 01-.348-.085l-3.57-1.84a.762.762 0 01-.327-1.028l.736-1.42a9.265 9.265 0 016.656-12.915l.737-1.421a.762.762 0 011.025-.327l3.571 1.839a.762.762 0 01.327 1.028l-.737 1.42a9.263 9.263 0 01-6.655 12.915l-.738 1.422a.762.762 0 01-.677.412zm-2.542-2.929l2.216 1.142.591-1.138a.762.762 0 01.674-.411c2.091-.006 4.331-1.631 5.575-4.044s1.263-5.179.054-6.886a.762.762 0 01-.055-.791l.588-1.134-2.216-1.141-.589 1.137a.762.762 0 01-.674.411c-2.09.006-4.331 1.631-5.575 4.044s-1.264 5.179-.055 6.886a.762.762 0 01.055.791z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38730",
  d: "M33.936 39.472a8.694 8.694 0 118.695-8.694 8.7 8.7 0 01-8.695 8.694zm0-15.864a7.17 7.17 0 107.171 7.17 7.179 7.179 0 00-7.171-7.174z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1466",
  d: "M41.866 31.535h-2.674a.762.762 0 01-.762-.762.762.762 0 01.762-.762h2.674a.762.762 0 01.764.762.762.762 0 01-.764.762z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1467",
  d: "M28.681 31.535h-2.675a.762.762 0 01-.762-.762.762.762 0 01.762-.762h2.675a.762.762 0 01.763.762.762.762 0 01-.763.762z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1468",
  d: "M33.936 39.53a.762.762 0 01-.762-.759v-2.779a.762.762 0 01.762-.762.762.762 0 01.762.762v2.779a.762.762 0 01-.762.759z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1469",
  d: "M33.936 26.318a.762.762 0 01-.762-.762v-2.71a.762.762 0 01.762-.762.762.762 0 01.762.762v2.71a.762.762 0 01-.762.762z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38731",
  d: "M37.811 57.42a4.637 4.637 0 01-4.637-4.627V38.739a.762.762 0 111.524 0v14.055a3.112 3.112 0 003.113 3.1 3.245 3.245 0 002.858-1.708l2.9-5.776a.762.762 0 011.362.684l-2.9 5.777a4.738 4.738 0 01-4.22 2.549z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1470",
  d: "M34.038 31.393a.76.76 0 01-.539-.223.762.762 0 010-1.077l2.956-2.956a.762.762 0 011.077 0 .762.762 0 010 1.077l-2.956 2.956a.76.76 0 01-.538.223z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38732",
  d: "M33.936 32.091a1.317 1.317 0 111.317-1.317 1.319 1.319 0 01-1.317 1.317z",
  fill: "#283c8c"
}))));
export default __webpack_public_path__ + "static/icon-pressure-cuff.753c2162d74725d61b3855d753755714.svg";
export { SvgIconPressureCuff as ReactComponent };